import axios from 'axios';

const axiosServices = axios.create({ baseURL: import.meta.env.VITE_APP_API_URL || 'http://localhost:3010/' });

const isPublicRoute = (pathname = '') => {
  const publicPaths = new Set([
    '/',
    '/login',
    '/register',
    '/forgot-password',
    '/check-mail',
    '/reset-password',
    '/code-verification',
    '/auth/login',
    '/auth/register'
  ]);

  return publicPaths.has(pathname);
};

// ==============================|| AXIOS - FOR MOCK SERVICES ||============================== //

axiosServices.interceptors.request.use(
  async (config) => {
    const accessToken = localStorage.getItem('serviceToken');
    if (accessToken) {
      config.headers['Authorization'] = `Bearer ${accessToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosServices.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 405) {
      // TODO::
      console.error('Something went wrong', error);
      // window.location.pathname = '/maintenance/500';
    }
    const currentPath = window.location.pathname;
    if ((error?.response?.status === 401 || error?.response?.status === 403) && !isPublicRoute(currentPath)) {
      // TODO::
      console.error('Something went wrong', error);
      window.location.pathname = '/login';
    }
    return Promise.reject((error?.response && error?.response?.data) || 'Wrong Services');
  }
);

export default axiosServices;

export const fetcher = async (args) => {
  const [url, config] = Array.isArray(args) ? args : [args];

  const res = await axiosServices.get(url, { ...config });

  return res.data;
};

export const fetcherPost = async (args) => {
  const [url, config] = Array.isArray(args) ? args : [args];

  const res = await axiosServices.post(url, { ...config });

  return res.data;
};
